module.exports = "/_next/static/images/logo-devpleno-dde2e46f2031b9ba1cc3cdf2c4a183e8.svg";